<template>
  <div class="ripple">
    <img src="../../assets/images/watermark1.jpg" alt="watermark" style="width:50px;height:50px" />
  </div>
</template>
<script>
export default {
  name: "ImageSpinner"
}
</script>